import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { TagEvent } from 'src/app/shared/models/dali-tags.model';
import { DocumentModel } from 'src/app/shared/models/document.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { IdentificationService } from 'src/app/shared/services/identification/identification.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
var RequestConsultComponent = /** @class */ (function () {
    function RequestConsultComponent(copyService, navigationService, bitacoraService, headerService, captureService, abreCuentasService, channelCommunicatorService, parametersService, identificationService, taggingService) {
        this.copyService = copyService;
        this.navigationService = navigationService;
        this.bitacoraService = bitacoraService;
        this.headerService = headerService;
        this.captureService = captureService;
        this.abreCuentasService = abreCuentasService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.parametersService = parametersService;
        this.identificationService = identificationService;
        this.taggingService = taggingService;
        this.bitacoraEvents = [
            'Successful_Search',
            'Not_found_case',
            'undated',
        ];
        this.notFound = false;
        this.client = {
            name: '',
            document: '',
        };
        this.isPostlogin = false;
        this.headerService.show(false, false, true);
    }
    RequestConsultComponent.prototype.ngOnInit = function () {
        this.channel = this.channelCommunicatorService.getChannelId();
        this.select_doc_type = this.parametersService.getSetting(OpEnum.DOC_TYPE);
        this.isPostlogin = this.abreCuentasService.getPostlogin();
        if (this.isPostlogin) {
            this.requests = this.abreCuentasService.getCustomerRequests();
            return;
        }
        this.formGroup = new FormGroup({
            doc_type: new FormControl('', Validators.required),
            doc_number: new FormControl('', [Validators.required]),
            requestNumber: new FormControl('', [Validators.required,
                Validators.minLength(6)]),
        });
    };
    RequestConsultComponent.prototype.onPrevious = function () {
        this.bitacoraService.saveDataInBitacora('return');
        this.navigationService.previousStep();
    };
    RequestConsultComponent.prototype.doc_type_change = function (e) {
        this.notFound = false;
        var target = e.value.id;
        var max_length_input = target === '1' ? 10 : (target === '2' ? 10 : 12);
        this.formGroup.controls.doc_number.setValidators([Validators.required,
            Validators.minLength(2), Validators.maxLength(max_length_input)]);
        this.formGroup.controls.doc_number.updateValueAndValidity();
        this.target_doc_type = {
            type_input: target === '1' || target === '2' ? 'number' : 'text',
            max_length: max_length_input,
        };
    };
    RequestConsultComponent.prototype.reactiveInputChange = function () {
        this.notFound = false;
        var control = this.formGroup.controls.doc_number;
        if (!this.target_doc_type) {
            control.setValue(control.value.replace(new RegExp(/[^\d]/), ''));
            return;
        }
        control.setValue(control.value.slice(0, this.target_doc_type.max_length));
        if (this.target_doc_type.type_input === 'number') {
            control.setValue(control.value.replace(new RegExp(/[^\d]/), ''));
        }
        else {
            control.setValue(control.value.replace(new RegExp(/[^A-Za-z0-9]/), ''));
        }
    };
    /**
     * Ejecuta el redireccionamiento según el código que se valida según el código de la solicitud
     */
    RequestConsultComponent.prototype.next = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var document;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.tagg('2');
                        return [4 /*yield*/, this.getClientInfo()];
                    case 1:
                        _a.sent();
                        if (this.notFound) {
                            return [2 /*return*/];
                        }
                        document = this.formGroup.controls.doc_number.value + "_" + this.formGroup.controls.doc_type.value.id;
                        this.requestNumber = this.formGroup.controls.requestNumber.value;
                        this.captureService.getRequestByNumber(this.requestNumber, document)
                            .then(function (res) {
                            if (res.user) {
                                _this.client.name = res.user.full_name;
                            }
                            if (res.code.startsWith('1') && res.code !== '100') {
                                res.code === '142' ? _this.sendBitacora(2) : _this.sendBitacora(1);
                                _this.navigationService.navigateToGeneralInformation(res.code);
                                return;
                            }
                            if (res.code === '100') {
                                _this.tagg('3');
                                _this.sendBitacora(1);
                                _this.notFound = true;
                                return;
                            }
                            _this.sendBitacora(0);
                            _this.setProductState(_this.abreCuentasService.getRequestModel(), res.isRefused);
                            _this.navigationService.nextStep();
                        })
                            .catch(function (error) {
                            console.error(error);
                            _this.navigationService.navigateToGeneralInformation('131');
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    RequestConsultComponent.prototype.nextSolicitation = function (solicitation) {
        this.tagg('2');
        this.abreCuentasService.setRequestModel(solicitation);
        this.setProductState(solicitation);
        this.navigationService.nextStep();
    };
    RequestConsultComponent.prototype.setProductState = function (solicitation, isrefused) {
        if (isrefused === void 0) { isrefused = false; }
        var anacreResponse = '';
        var status = solicitation.solicitation_status;
        var phase = solicitation.solicitation_phase;
        /* istanbul ignore next */
        if (typeof solicitation.credit_analisys === 'undefined') {
            return;
        }
        var creditResponse = solicitation.credit_analisys
            .find(function (element) { return element.key === 'RESPUESTA'; });
        anacreResponse = creditResponse ? creditResponse.name : '';
        if (isrefused) {
            this.abreCuentasService.setTransactionStatus('Rechazado');
        }
        else if (phase === '10' || (phase === '04' && anacreResponse === 'APROBADO')) {
            this.abreCuentasService.setTransactionStatus('Aprobado');
        }
        else {
            this.abreCuentasService.setTransactionStatus('EnProceso');
        }
    };
    RequestConsultComponent.prototype.getClientInfo = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var info, resInfo;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        info = new DocumentModel();
                        info.birthdate = '';
                        info.document_number = this.formGroup.controls.doc_number.value;
                        info.document_type = this.formGroup.controls.doc_type.value.type;
                        info.firstname = '';
                        info.middlename = '';
                        info.primary_lastname = '';
                        info.second_lastname = '';
                        info.sex = '';
                        this.abreCuentasService.setDocumentInfo(info);
                        return [4 /*yield*/, this.identificationService.validateIfClientExists(info)];
                    case 1:
                        resInfo = _a.sent();
                        if (resInfo.notFound) {
                            this.tagg('3');
                            this.notFound = true;
                            return [2 /*return*/];
                        }
                        this.client.name = resInfo.document.first_name;
                        this.client.document = resInfo.document.number;
                        if (resInfo.client && !this.isPostlogin && this.channel !== CHANNEL.PORTALO.CODE) {
                            this.navigationService.navigateToGeneralInformation('140');
                            this.notFound = true;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Valida solo numeros y longitud del campo de número de solicitud
     */
    RequestConsultComponent.prototype.keyPressRequest = function (event) {
        this.notFound = false;
        var cadena = event.key;
        var patron = /\D/;
        if (patron.test(cadena)) {
            return false;
        }
        return true;
    };
    /**
     * Envía el string de la bitacora con el resultado y los datos del usuario
     * @param event
     * @param user
     */
    RequestConsultComponent.prototype.sendBitacora = function (event) {
        var actualDate = new Date();
        var dateStr = this.abreCuentasService.formatDate(actualDate);
        var dateArr = dateStr.split('T');
        var bitacoraEvent = this.bitacoraEvents[event] + "_" + (this.client.name ?
            this.client.name.replace(' ', '_')
            : '') + "_" + dateArr[0] + "_" + dateArr[0] + "_" + this.client.document;
        console.log('bitacoraEvern ', bitacoraEvent);
        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    };
    /**
     * Retorna un mensaje de error según el tipo de identificación escogida
     * @returns string
     */
    RequestConsultComponent.prototype.printErrorMessage = function () {
        switch (this.formGroup.controls.doc_type.value.id) {
            case '1':
                return this.copyService.copies.request_consult_copies.doc_num.error_cc;
            case '2':
                return this.copyService.copies.request_consult_copies.doc_num.error_ce;
            case '5':
                return this.copyService.copies.request_consult_copies.doc_num.error_pas;
            default:
                return this.copyService.copies.request_consult_copies.doc_num.error;
        }
    };
    RequestConsultComponent.prototype.tagg = function (tag_number) {
        var tagPageName = this.navigationService.getCurrentStep().tag_name;
        try {
            var changes = this.taggingService.createTagChanges(tagPageName, tag_number);
            var event_1 = {
                category: {
                    module: EVENT.customCategory.module.body,
                    type: EVENT.customCategory.type.button,
                    position: EVENT.customCategory.position.bottom,
                },
                action: EVENT.customAction.click,
                label: EVENT[tagPageName + "E" + tag_number + "customLabel"],
            };
            switch (tag_number) {
                case '2':
                    event_1.category = {
                        module: EVENT.customCategory.module.body,
                        type: EVENT.customCategory.type.button,
                        position: this.isPostlogin ? EVENT.customCategory.position.center : EVENT.customCategory.position.bottom,
                    };
                    event_1.action = EVENT.customAction.click;
                    break;
                case '3':
                    event_1.category = {
                        module: EVENT.customCategory.module.body,
                        type: EVENT.customCategory.type.warning,
                        position: EVENT.customCategory.position.top,
                    };
                    event_1.action = EVENT.customAction.show;
                    event_1.errorName = this.navigationService.camelize(this.copyService.copies.request_consult_copies.not_found_label);
                    break;
            }
            this.taggingService.pageTagEvent(event_1, changes);
        }
        catch (error) {
            console.log("Error en " + error);
        }
    };
    RequestConsultComponent.prototype.formatDate = function (date) {
        var mydate = new Date(date);
        var day = mydate.getDate().toString();
        var month = (mydate.getMonth() + 1).toString();
        var year = mydate.getFullYear();
        if (+day < 10) {
            day = "0" + day;
        }
        if (+month < 10) {
            month = "0" + month;
        }
        return day + "/" + month + "/" + year;
        // return date ? date.split('T')[0].replace(new RegExp('-', 'g'), '/') : '';
    };
    return RequestConsultComponent;
}());
export { RequestConsultComponent };
